export default "__VITE_ASSET__f02dRGFp__"